if (!customElements.get('email-popup-modal')) {
  class EmailPopupModal extends HTMLElement {
    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'kewels-email-popup-v1';
      this.delayMs = (parseInt(this.dataset.delay, 10) || 15) * 1000;
      this.timer = null;
      this.onClose = this.close.bind(this);
      this.onKeyUp = this.handleKeyUp.bind(this);
    }

    connectedCallback() {
      if (this.shouldSkip()) return;

      this.querySelectorAll('[data-email-popup-close]').forEach((element) => {
        element.addEventListener('click', this.onClose);
      });

      const form = this.querySelector('form');
      form?.addEventListener('submit', () => this.markDismissed());

      const successState = this.querySelector('[data-signup-success]');
      if (successState) {
        this.markDismissed();
        this.open(true);
        return;
      }

      if (this.querySelector('#EmailPopupError')) {
        this.open(true);
        return;
      }

      if (window.Shopify?.designMode) return;

      this.timer = window.setTimeout(() => this.open(), this.delayMs);
    }

    disconnectedCallback() {
      if (this.timer) window.clearTimeout(this.timer);
      this.querySelectorAll('[data-email-popup-close]').forEach((element) => {
        element.removeEventListener('click', this.onClose);
      });
      document.removeEventListener('keyup', this.onKeyUp);
    }

    shouldSkip() {
      if (this.dataset.customerSubscribed === 'true') {
        this.markDismissed();
        return true;
      }

      try {
        return window.localStorage.getItem(this.storageKey) === '1';
      } catch (_error) {
        return false;
      }
    }

    markDismissed() {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch (_error) {
        /* localStorage unavailable */
      }
    }

    open(fromSuccess = false) {
      if (!fromSuccess && this.shouldSkip()) return;

      this.hidden = false;
      window.requestAnimationFrame(() => {
        this.classList.add('is-visible');
      });

      document.body.classList.add('overflow-hidden');
      document.addEventListener('keyup', this.onKeyUp);

      const focusTarget = this.querySelector('.email-popup__input') || this.querySelector('.email-popup__close');
      if (typeof trapFocus === 'function' && focusTarget) {
        trapFocus(this, focusTarget);
      } else {
        focusTarget?.focus();
      }
    }

    close() {
      this.classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keyup', this.onKeyUp);

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }

      this.markDismissed();

      window.setTimeout(() => {
        this.hidden = true;
      }, 450);
    }

    handleKeyUp(event) {
      if (event.code?.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    }
  }

  customElements.define('email-popup-modal', EmailPopupModal);
}
